module.exports = __webpack_public_path__ + "static/snake-and-bat-red-8f209751b14b960d83aca62b6ed983b8.png";